import { gql, useQuery } from "@apollo/client";

export const Technicians = gql`
	query Technicians($term: String, $limit: Int, $offSet: Float) {
		technicians(
			paginationInfo: { term: $term, limit: $limit, offSet: $offSet }
		) {
			data {
				_id
				email
				name
				phoneNumber
				addressInfo {
					Address
					postalCode
				}
				localidade
				nif
				avatar
				createdAt
			}
			paginantionInfo {
				numberDocuments
				currentSkip
			}
		}
	}
`;
